import { c as _c } from "react/compiler-runtime";
import type { ComponentProps, Ref } from "react";
import { useEffect, useState } from "react";
import { twMergeClasses } from "@/utils/twMergeClasses";
interface IBackdropProps extends ComponentProps<"div"> {
  isOpen: boolean;
  ref?: Ref<HTMLDivElement>;
}
export function Backdrop(t0) {
  const $ = _c(15);
  let className;
  let divProps;
  let isOpen;
  let ref;
  if ($[0] !== t0) {
    ({
      isOpen,
      ref,
      className,
      ...divProps
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = divProps;
    $[3] = isOpen;
    $[4] = ref;
  } else {
    className = $[1];
    divProps = $[2];
    isOpen = $[3];
    ref = $[4];
  }
  const [isVisible, setIsVisible] = useState(false);
  let t1;
  let t2;
  if ($[5] !== isOpen) {
    t1 = () => {
      setIsVisible(isOpen);
    };
    t2 = [isOpen];
    $[5] = isOpen;
    $[6] = t1;
    $[7] = t2;
  } else {
    t1 = $[6];
    t2 = $[7];
  }
  useEffect(t1, t2);
  const t3 = isVisible ? "opacity-100 visible" : "opacity-0 invisible";
  let t4;
  if ($[8] !== className || $[9] !== t3) {
    t4 = twMergeClasses("fixed inset-0 bg-white/70 z-40 transition-all duration-500", t3, className);
    $[8] = className;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== divProps || $[12] !== ref || $[13] !== t4) {
    t5 = <div ref={ref} aria-hidden="true" className={t4} {...divProps} />;
    $[11] = divProps;
    $[12] = ref;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}